import React from 'react'
import { ChatBar } from './chat-bar'
import style from './index.module.sass'
import { Messages } from './messages'
import { useLlm } from './useLlm'

type Props = {
	chatId: string
	resetChatId: () => void
}

export const Chat = ({ chatId, resetChatId }: Props) => {
	const { send, messages, awaitingResponse } = useLlm({ chatId, resetChatId })
	return (
		<div className={style.container} key={chatId}>
			<Messages messages={messages} />

			<ChatBar awaitingResponse={awaitingResponse} send={send} hasMessages={messages.length > 0} />
		</div>
	)
}
